import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom"
import { Button, Card, Col, Form, Modal, OverlayTrigger, Row, Table, Toast, Tooltip } from 'react-bootstrap'
import classes from "./ProgramsAddEdit.module.css";
// import queryString from 'query-string';
import DayBox from './DayBox';
import {getTrainerParam} from '../../util/util'
import {
    startProgramBuild,
    addEventToProgram,
    getAllProgramEvents,
    assignProgramToClients,
    editProgramEvent,
    deleteEvent,
    addMessageToProgram,
    getFavoriteDetails,
    getMessageTemplates,
    editProgramBuildLength,
    editProgramBuildName,
    editProgramBuildNotes,
    deleteAllEvents
} from "./ProgramsAddEditSlice";



const ProgramsAddEdit = (props) => {
    const [programLength, setProgramLength] = useState(0)
    const [programName, setProgramName] = useState("")
    const [programNotes, setProgramNotes] = useState("")
    const trainer = getTrainerParam()
    const trainerParam = trainer ? `&trainer=${trainer}` : ''
    const dispatch = useDispatch();

    const history = useHistory()

    const submitHandler = (e) => {

        e.preventDefault();

        const payload = {
            programLength,
            programName,
            programNotes
        }

        dispatch(startProgramBuild(payload))
        .then((res) => {
            const {programID} = res.payload
            console.log(res.payload)
            history.push(`/program-editor?id=${programID}${trainerParam}`)
        })

    }

    return (
        <div className="p-3" id="containerDiv">
            <h1 style={{lineHeight:'1.5'}}>Program</h1>
            <hr />
            <Card className={classes.programsBox} style={{backgroundColor: '#F7F8F9' }}>
                <Form>
                    <Form.Group as={Row} controlId="programLength">
                        <Form.Label column sm={2}>
                            Program Length (Days)
                        </Form.Label>
                        <Col sm={10}>
                            <Form.Control
                                placeholder="required"
                                type="number"
                                min="1"
                                onChange={(e) => { 
                                    setProgramLength(e.target.value.replace(/\D/g,''))
                                } }
                                value={programLength}
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="programName">
                        <Form.Label column sm={2}>
                            Program Name
                        </Form.Label>
                        <Col sm={10}>
                            <Form.Control
                                type="text"
                                placeholder="required"
                                onChange={(e) => {setProgramName(e.target.value) }}
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row}>
                        <Form.Label column sm={2}>
                            Program Notes
                                </Form.Label>
                        <Col sm={10}>
                            {(programNotes !== "") && 
                                <span 
                                    style={{
                                        backgroundColor: "transparent",
                                        border: 0,
                                        outline: 0,
                                        padding: "0px 6px 0px 0px",
                                        position: "absolute",
                                        top: 0,
                                        right: "15px",
                                        height: "100%",
                                        display: "table-cell",
                                        verticalAlign: "middle",
                                        cursor:"pointer"
                                    }}
                                    onClick={(e) => { (document.getElementById("notesForm").value=""); setProgramNotes("")}}
                                >&#x2612;</span>
                            }
                            <Form.Control
                                placeholder="optional"
                                as="textarea"
                                id="notesForm"
                                rows={2}
                                onChange={(e) => {setProgramNotes(e.target.value) }}
                            />

                        </Col>

                    </Form.Group>
                    <Button
                        variant="outline-success"
                        style={{
                            float: "right",
                        }}
                        // type="submit"
                        onClick={(e) => { submitHandler(e) }}
                    >
                        Start Building
                    </Button>

                </Form>
            </Card>

        </div>
    )
}

export default ProgramsAddEdit
